import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import PluviometroList from './pluviometroList';
import * as pluviometroActions from './pluviometroActions';
import SelectConfGrupoFisicoPluviometro from '../common/selectdb/selectConfGrupoFisicoPluviometro';
import SelectConfControladorPluviometroHistorico from '../common/selectdb/selectConfControladorPluviometroHistorico';
import ButtonTooltip from '../common/form/buttonTooltip';
import { getConfig } from '../configuracao/configLocal';
import moment from 'moment';
import Chart from 'chart.js';
import axiosInstance from '../main/axios';

class PluviometroHistorico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshKey: 0,
      printLoading: false,
    };
    this.changeControlador = this.changeControlador.bind(this);
    this.imprimirRelatorio = this.imprimirRelatorio.bind(this);
  }

  changeControlador() {
    // Qualquer mudança em grupo/controlador força recarregar os dados do List
    this.setState(prev => ({ refreshKey: prev.refreshKey + 1 }));
  }

  // Função para determinar cor por intensidade de chuva
  getColorByIntensity(mm) {
    if (mm <= 1.25) return 'rgba(40,167,69,0.35)'; // verde fraca
    if (mm <= 6.25) return 'rgba(255,193,7,0.45)'; // amarela moderada
    if (mm <= 12.5) return 'rgba(255,159,64,0.55)'; // laranja forte
    return 'rgba(220,53,69,0.55)'; // vermelha muito forte
  }

  async imprimirRelatorio() {
    const controladorSelecionado = getConfig('cont');
    const { historico } = this.props;

    if (!controladorSelecionado) {
      alert('Selecione um controlador para gerar o relatório.');
      return;
    }

    // Sempre usar dados do histórico para gerar gráfico e relatório
    let dadosParaRelatorio = Array.isArray(historico) ? historico : (historico && historico.dados) || [];
    let agrupamentoUsado = '15min'; // padrão
    let periodoRelatorio = { dataInicio: null, dataFim: null };

    if (dadosParaRelatorio.length === 0) {
      // Tentar recuperar filtros persistidos e buscar do backend
      try {
        const persisted = localStorage.getItem('pluviometro_filtros');
        if (persisted) {
          const parsed = JSON.parse(persisted);
          const controladorId = parsed.controladorId || controladorSelecionado;
          const filtros = parsed.filtros || {};
          agrupamentoUsado = filtros.agrupamento || '15min';
          periodoRelatorio.dataInicio = filtros.dataInicio;
          periodoRelatorio.dataFim = filtros.dataFim;
          const params = new URLSearchParams();
          if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
          if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
          if (filtros.agrupamento) params.append('agrupamento', filtros.agrupamento);
          const url = `/pluviometro/historico/${controladorId}${params.toString() ? '?' + params.toString() : ''}`;
          const resp = await axiosInstance.get(url);
          if (resp && resp.data && Array.isArray(resp.data.dados)) {
            dadosParaRelatorio = resp.data.dados;
          }
        }
      } catch (e) {
        // segue para validação abaixo
      }
      if (dadosParaRelatorio.length === 0) {
        alert('Nenhum dado encontrado para impressão. Faça uma busca primeiro.');
        return;
      }
    } else {
      // Se tem dados do histórico, tentar recuperar filtros do localStorage
      try {
        const persisted = localStorage.getItem('pluviometro_filtros');
        if (persisted) {
          const parsed = JSON.parse(persisted);
          const filtros = parsed.filtros || {};
          agrupamentoUsado = filtros.agrupamento || '15min';
          periodoRelatorio.dataInicio = filtros.dataInicio;
          periodoRelatorio.dataFim = filtros.dataFim;
        }
      } catch (e) {
        // usar padrão
      }
    }

    try {
      this.setState({ printLoading: true });
      // Abrir janela imediatamente para não ser bloqueado pelo navegador
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        this.setState({ printLoading: false });
        alert('Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.');
        return;
      }
      // Placeholder enquanto gera o conteúdo
      printWindow.document.write(
        '<html><head><title>Gerando Relatório...</title></head><body><p style="font-family: Arial; color:#666;">Gerando relatório...</p></body></html>',
      );

      // Definir nome do controlador usando numero_controlador ao invés do ID
      let nomeControlador = 'Todos';
      if (controladorSelecionado && controladorSelecionado !== 'todos') {
        let numeroControlador = controladorSelecionado;

        try {
          // Backend já expõe numero_controlador nesta rota
          const respConfig = await axiosInstance.get(`/pluviometro/config/${controladorSelecionado}`);
          if (respConfig && respConfig.data && respConfig.data.numero_controlador) {
            numeroControlador = respConfig.data.numero_controlador;
          }
        } catch (e) {
          // Em caso de erro, segue usando o ID como fallback
          // console.warn('Erro ao buscar numero_controlador para relatório:', e);
        }

        nomeControlador = `Controlador ${numeroControlador}`;
      }

      // Função para converter agrupamento em texto legível
      const getAgrupamentoTexto = agrup => {
        switch (agrup) {
          case '15min':
            return '15 minutos';
          case '30min':
            return '30 minutos';
          case '60min':
            return '60 minutos';
          case 'dia':
            return 'Por Dia';
          case 'mes':
            return 'Por Mês';
          default:
            return '15 minutos';
        }
      };

      const agrupamentoTexto = getAgrupamentoTexto(agrupamentoUsado);
      const periodoTexto =
        periodoRelatorio.dataInicio && periodoRelatorio.dataFim
          ? `${moment(periodoRelatorio.dataInicio).format('DD/MM/YYYY')} a ${moment(periodoRelatorio.dataFim).format(
              'DD/MM/YYYY',
            )}`
          : 'Período atual';

      // Ordenar dados cronologicamente para o gráfico
      const dadosOrdenados = [...dadosParaRelatorio].sort((a, b) => {
        const dataA = moment(`${a.data} ${a.hora || '00'}:${a.minuto || '00'}`);
        const dataB = moment(`${b.data} ${b.hora || '00'}:${b.minuto || '00'}`);
        return dataA.diff(dataB);
      });

      // Gerar gráfico como imagem base64 (sempre usando formato do histórico)
      const chartImageBase64 = await this.generateChartImage(dadosOrdenados, 'historico');

      // Calcular totais
      const totalChuva = dadosParaRelatorio.reduce((acc, it) => acc + (it.total_chuva || 0), 0);
      const maiorLeitura = dadosParaRelatorio.reduce((acc, it) => Math.max(acc, it.total_chuva || 0), 0);
      const mediaChuvaPeriodo = dadosParaRelatorio.length > 0 ? totalChuva / dadosParaRelatorio.length : 0;

      let html = `
        <html>
          <head>
            <title>Relatório Pluviômetro - ${nomeControlador}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; color: #333; }
              .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 10px; }
              .kpis { display: flex; justify-content: space-around; margin: 20px 0; }
              .kpi { 
                background: #f8f9fa; 
                border: 1px solid #e9ecef; 
                border-radius: 8px; 
                padding: 15px; 
                text-align: center; 
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                flex: 1;
                margin: 0 5px;
              }
              .kpi-value { font-size: 1.5rem; font-weight: bold; margin-bottom: 5px; }
              .kpi-label { color: #6c757d; font-size: 0.9rem; }
              .chart-container { text-align: center; margin: 30px 0; }
              .chart-img { max-width: 100%; height: auto; border: 1px solid #ddd; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-weight: bold; color: #6c757d; }
              .text-right { text-align: right; }
              .total { font-weight: bold; background-color: #f9f9f9; }
              .legend-color { -webkit-print-color-adjust: exact !important; color-adjust: exact !important; print-color-adjust: exact !important; }
              @media print { 
                body { margin: 0; -webkit-print-color-adjust: exact; color-adjust: exact; print-color-adjust: exact; } 
                .header { page-break-inside: avoid; }
                .chart-container { page-break-inside: avoid; }
                .legend-color { -webkit-print-color-adjust: exact !important; color-adjust: exact !important; print-color-adjust: exact !important; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>Relatório do Pluviômetro - Histórico</h2>
              <p><strong>Controlador:</strong> ${nomeControlador}</p>
              <p><strong>Período:</strong> ${periodoTexto}</p>
              <p><strong>Agrupamento:</strong> ${agrupamentoTexto}</p>
              <p><strong>Data de Geração:</strong> ${moment().format('DD/MM/YYYY HH:mm:ss')}</p>
            </div>
            
            <!-- KPIs -->
            <div class="kpis">
              <div class="kpi">
                <div class="kpi-value" style="color: #007bff;">${totalChuva.toFixed(2)} mm</div>
                <div class="kpi-label">Total no Período</div>
              </div>
              <div class="kpi">
                <div class="kpi-value" style="color: #28a745;">${maiorLeitura.toFixed(2)} mm</div>
                <div class="kpi-label">Maior Leitura</div>
              </div>
              <div class="kpi">
                <div class="kpi-value" style="color: #ffc107;">${mediaChuvaPeriodo.toFixed(2)} mm</div>
                <div class="kpi-label">Média de Chuva</div>
              </div>
            </div>

            <!-- Gráfico -->
            <div class="chart-container">
              <h3>Gráfico de Chuva</h3>
              <div style="display: flex; gap: 20px; align-items: center; justify-content: center; margin-bottom: 15px; font-size: 12px; color: #555;">
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <span class="legend-color" style="width: 14px; height: 14px; border-radius: 3px; background: #28a745; border: 1px solid #333; display: inline-block;"></span>
                  Fraca (≤ 1.25 mm)
                </span>
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <span class="legend-color" style="width: 14px; height: 14px; border-radius: 3px; background: #ffc107; border: 1px solid #333; display: inline-block;"></span>
                  Moderada (≤ 6.25 mm)
                </span>
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <span class="legend-color" style="width: 14px; height: 14px; border-radius: 3px; background: #ff9f40; border: 1px solid #333; display: inline-block;"></span>
                  Forte (≤ 12.5 mm)
                </span>
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <span class="legend-color" style="width: 14px; height: 14px; border-radius: 3px; background: #dc3545; border: 1px solid #333; display: inline-block;"></span>
                  Muito Forte (> 12.5 mm)
                </span>
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <span class="legend-color" style="width: 14px; height: 3px; border-radius: 1px; background: #007bff; border: 1px solid #333; display: inline-block;"></span>
                  Acumulada
                </span>
              </div>
              <img src="${chartImageBase64}" class="chart-img" alt="Gráfico de Chuva" />
            </div>

            <!-- Tabela -->
            <h3>Dados Detalhados</h3>
            <table>
              <thead>
                <tr>
                  <th>Data/Hora</th>
                  <th class="text-right">Chuva (mm)</th>
                </tr>
              </thead>
              <tbody>
      `;

      // Dados da tabela com cores (ordenados por data decrescente para tabela)
      const dadosTabela = [...dadosParaRelatorio].sort((a, b) => {
        const dataA = moment(`${a.data} ${a.hora || '00'}:${a.minuto || '00'}`);
        const dataB = moment(`${b.data} ${b.hora || '00'}:${b.minuto || '00'}`);
        return dataB.diff(dataA);
      });

      dadosTabela.forEach(item => {
        const chuvaValue = item.total_chuva || 0;
        const bgColor = this.getColorByIntensity(chuvaValue);

        let dataHoraFormatada;
        // Mesma lógica da tabela em pluviometroList.jsx
        if (agrupamentoUsado === 'dia') {
          dataHoraFormatada = moment(item.data).format('DD/MM/YYYY');
        } else if (agrupamentoUsado === 'mes') {
          dataHoraFormatada = moment(item.data).format('MM/YYYY');
        } else if (item.minuto !== undefined) {
          dataHoraFormatada = `${moment(item.data).format('DD/MM/YYYY')} ${item.hora}:${String(
            item.minuto || 0,
          ).padStart(2, '0')}`;
        } else {
          dataHoraFormatada = `${moment(item.data).format('DD/MM/YYYY')} ${item.hora}:00`;
        }

        html += `
          <tr>
            <td>${dataHoraFormatada}</td>
            <td class="text-right" style="background-color: ${bgColor}; font-weight: bold;">${chuvaValue.toFixed(
          2,
        )}</td>
          </tr>
        `;
      });

      html += `
              <tr class="total">
                <td><strong>TOTAL</strong></td>
                <td class="text-right"><strong>${totalChuva.toFixed(2)} mm</strong></td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
      `;

      // Escrever na janela já aberta
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      // Pequeno atraso para garantir render do conteúdo antes do print
      setTimeout(() => {
        try {
          printWindow.print();
        } catch (e) {}
        try {
          printWindow.close();
        } catch (e) {}
      }, 50);
    } catch (error) {
      console.error('Erro ao imprimir:', error);
      alert(`Erro ao gerar relatório para impressão: ${error.message || error}. Tente novamente.`);
    } finally {
      this.setState({ printLoading: false });
    }
  }

  async generateChartImage(dadosOrdenados, tipoRelatorio = 'historico') {
    return new Promise(resolve => {
      // Criar canvas temporário
      const canvas = document.createElement('canvas');
      canvas.width = 800;
      canvas.height = 400;
      const ctx = canvas.getContext('2d');

      // Verificar se Chart.js está disponível (global ou importado)
      const ChartJS =
        typeof window !== 'undefined' && window.Chart ? window.Chart : typeof Chart !== 'undefined' ? Chart : null;
      if (!ChartJS) {
        console.warn('Chart.js não encontrado, usando imagem placeholder');
        resolve(
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
        );
        return;
      }

      // Preparar dados do gráfico
      const labels = dadosOrdenados.map(item => {
        if (item.minuto !== undefined) {
          // Calcular horário do fim do período para agrupamentos com minutos
          const inicioMoment = moment(
            `${item.data} ${String(item.hora || 0).padStart(2, '0')}:${String(item.minuto).padStart(2, '0')}`,
            'YYYY-MM-DD HH:mm',
          );
          // Assumir agrupamento de 15min como padrão se não especificado
          const fimMoment = inicioMoment.clone().add(15, 'minutes');
          return `${fimMoment.format('DD/MM')} ${fimMoment.format('HH:mm')}`;
        } else {
          // Para agrupamento por hora, mostrar fim da hora
          const inicioMoment = moment(`${item.data} ${String(item.hora || 0).padStart(2, '0')}:00`, 'YYYY-MM-DD HH:mm');
          const fimMoment = inicioMoment.clone().add(1, 'hour');
          return `${fimMoment.format('DD/MM')} ${fimMoment.format('HH')}h`;
        }
      });

      const data = dadosOrdenados.map(item => item.total_chuva || 0);
      const backgroundColors = dadosOrdenados.map(item => this.getColorByIntensity(item.total_chuva || 0));
      const borderColors = backgroundColors.map(bg =>
        bg
          .replace('0.35)', '0.8)')
          .replace('0.45)', '0.9)')
          .replace('0.55)', '0.95)'),
      );

      // Calcular chuva acumulada para impressão - sempre crescente
      const acumulado = [];
      let somaAcumulada = 0;
      data.forEach((val, idx) => {
        somaAcumulada += val;
        acumulado[idx] = Number(somaAcumulada.toFixed(2));
      });

      // Calcular escala máxima unificada para impressão
      const maxIntensidadeImpressao = Math.max(...data, 0);
      const maxAcumuladoImpressao = Math.max(...acumulado, 0);
      const maxEscalaImpressao = Math.max(maxIntensidadeImpressao, maxAcumuladoImpressao);
      // Adicionar margem mínima e arredondar para múltiplos de 0.5 para evitar números como 3.3000000000003
      // Se já é múltiplo de 0.5, adiciona apenas 0.5. Senão, arredonda para o próximo múltiplo de 0.5
      let maxEscalaImpressaoComMargem;
      if (maxEscalaImpressao > 0) {
        const proximoMultiplo = Math.ceil(maxEscalaImpressao / 0.5) * 0.5;
        maxEscalaImpressaoComMargem =
          maxEscalaImpressao === proximoMultiplo ? maxEscalaImpressao + 0.5 : proximoMultiplo;
      } else {
        maxEscalaImpressaoComMargem = 1;
      }

      // Criar gráfico combo
      const chartInstance = new ChartJS(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              type: 'bar',
              label: 'Chuva (mm)',
              data: data,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
              yAxisID: 'y-axis-1',
            },
            {
              type: 'line',
              label: 'Chuva Acumulada (mm)',
              data: acumulado,
              borderColor: '#007bff',
              backgroundColor: 'rgba(0,123,255,0.1)',
              borderWidth: 2,
              fill: false,
              pointRadius: 2,
              pointHoverRadius: 4,
              yAxisID: 'y-axis-2',
            },
          ],
        },
        options: {
          responsive: false,
          animation: false,
          legend: { display: false },
          scales: {
            xAxes: [
              {
                gridLines: { display: false },
                ticks: { fontColor: '#666', fontSize: 11 },
              },
            ],
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                position: 'left',
                gridLines: { color: 'rgba(0,0,0,0.06)' },
                ticks: {
                  fontColor: '#666',
                  fontSize: 11,
                  beginAtZero: true,
                  max: maxEscalaImpressaoComMargem,
                  callback: value => `${value} mm`,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Intensidade (mm)',
                  fontColor: '#333',
                  fontStyle: 'bold',
                  fontSize: 12,
                },
              },
              {
                id: 'y-axis-2',
                type: 'linear',
                position: 'right',
                gridLines: { display: false },
                ticks: {
                  fontColor: '#007bff',
                  fontSize: 11,
                  beginAtZero: true,
                  max: maxEscalaImpressaoComMargem,
                  callback: value => `${value} mm`,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Acumulado (mm)',
                  fontColor: '#007bff',
                  fontStyle: 'bold',
                  fontSize: 12,
                },
              },
            ],
          },
        },
      });

      // Garantir que o desenho terminou antes de capturar
      try {
        if (chartInstance && typeof chartInstance.update === 'function') {
          chartInstance.update(0);
        }
        // Esperar próximo frame para ter certeza que o canvas foi pintado
        const finalize = () => {
          try {
            const imageBase64 = canvas.toDataURL('image/png');
            resolve(imageBase64);
          } finally {
            if (chartInstance && typeof chartInstance.destroy === 'function') chartInstance.destroy();
          }
        };
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(finalize);
        } else {
          setTimeout(finalize, 0);
        }
      } catch (e) {
        // Em caso de falha, ainda resolver com placeholder
        resolve(
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
        );
        if (chartInstance && typeof chartInstance.destroy === 'function') chartInstance.destroy();
      }
    });
  }

  render() {
    return (
      <div>
        <div className="contentHeaderFilter pluviometro-historico-filter">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <SelectConfGrupoFisicoPluviometro onChange={this.changeControlador} />
          </div>
          <SelectConfControladorPluviometroHistorico anel={false} onChange={this.changeControlador} />
          <ButtonTooltip
            type="button"
            icon={this.state.printLoading ? 'spinner fa-spin' : 'print'}
            label=""
            className="default btn-sm"
            data-title={this.state.printLoading ? 'Gerando relatório...' : 'Imprimir Relatório'}
            onClick={this.imprimirRelatorio}
            disabled={this.state.printLoading}
          />
        </div>
        <Content>
          <PluviometroList activeTab="historico" refreshKey={this.state.refreshKey} />
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  historico: state.pluviometro.historico,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...pluviometroActions,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PluviometroHistorico);
